import { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Loads this company's apps (see cloud-backend server.py's identify_app,
 * which upserts one unnamed row per first-seen app_id) and resolves an
 * app_id to its admin-given app_name wherever the dashboard would otherwise
 * show the raw id. Polls like every other page here so a name set from the
 * Devices tab shows up elsewhere without a manual refresh.
 */
export function useAppNames() {
  const [apps, setApps] = useState([]);

  const reload = useCallback(() => {
    api.get("/apps").then(({ data }) => setApps(data)).catch(() => {});
  }, []);

  useEffect(() => {
    reload();
    const interval = setInterval(reload, 10000);
    return () => clearInterval(interval);
  }, [reload]);

  const byId = Object.fromEntries(apps.map((a) => [a.app_id, a]));
  const appLabel = (appId) => (appId ? byId[appId]?.app_name || appId : appId);

  return { apps, byId, appLabel, reload };
}
